export var DeviceName;
(function (DeviceName) {
    DeviceName["Android"] = "Android";
    DeviceName["Chrome"] = "Chrome";
    DeviceName["Edge"] = "Edge";
    DeviceName["Firefox"] = "Firefox";
    DeviceName["iOS"] = "iOS";
    DeviceName["Linux"] = "Linux";
    DeviceName["MacOS"] = "macOS";
    DeviceName["Opera"] = "Opera";
    DeviceName["Safari"] = "Safari";
    DeviceName["Windows"] = "Windows";
})(DeviceName || (DeviceName = {}));
//# sourceMappingURL=device-name.const.js.map